import { del, get, patch, post, put } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToJSON, operationToPaginatedJSON, paginateAPIOptions, } from "../util/amplify-utils";
//Pass this value to ModifySpecificAssetParams.device_id to unpair the asset
export const MODIFY_SPECIFIC_ASSET_UNPAIR_DEVICE_ID = "None";
export default class VelavuAPIAssets {
    //This endpoint retrieves all assets.
    //https://docs.velavu.com/#get-all-assets
    getAllAssets(params, pagination) {
        const query = {};
        if (params?.include_profile_images !== undefined) {
            query["include_profile_images"] = String(params.include_profile_images);
        }
        if (params?.paired !== undefined) {
            query["paired"] = String(params.paired);
        }
        if (params?.online !== undefined) {
            query["online"] = String(params.online);
        }
        if (params?.only_registered !== undefined) {
            query["only_registered"] = String(params.only_registered);
        }
        if (params?.category !== undefined) {
            query["category"] = params.category;
        }
        if (params?.group !== undefined) {
            query["group"] = params.group;
        }
        if (params?.name !== undefined) {
            query["name"] = params.name;
        }
        return normalizePromiseError(operationToPaginatedJSON(get({
            apiName: API_NAME_VELAVU,
            path: "/assets",
            options: paginateAPIOptions(pagination, {
                queryParams: query,
            }),
        })));
    }
    //This creates a new Asset object.
    //https://docs.velavu.com/#create-a-new-asset
    createNewAsset(params) {
        return normalizePromiseError(operationToJSON(post({
            apiName: API_NAME_VELAVU,
            path: "/assets",
            options: {
                body: params,
            },
        })));
    }
    //This request returns the entire data of a requested asset.
    //https://docs.velavu.com/#get-a-specific-asset
    getSpecificAsset(asset_id) {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: `/assets/${asset_id}`,
        })));
    }
    //This endpoint modifies one or more properties of the asset.
    //https://docs.velavu.com/#modify-a-specific-asset
    modifySpecificAsset(asset_id, params) {
        return normalizePromiseError(operationToJSON(patch({
            apiName: API_NAME_VELAVU,
            path: `/assets/${asset_id}`,
            options: {
                body: params,
            },
        })));
    }
    //This method deletes a specific asset.
    //https://docs.velavu.com/#delete-a-specific-asset
    deleteSpecificAsset(asset_id) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: `/assets/${asset_id}`,
        }).response);
    }
    //This method uploads a profile picture for an asset.
    //https://docs.velavu.com/#upload-a-profile-picture-for-an-asset
    uploadProfilePicture(asset_id, data_base_64) {
        return normalizePromiseError(operationToJSON(put({
            apiName: API_NAME_VELAVU,
            path: `/assets/${asset_id}/profile_img`,
            options: {
                body: {
                    image: data_base_64,
                },
            },
        })));
    }
    //This method deletes an asset's profile image.
    //https://docs.velavu.com/#delete-a-profile-picture-for-an-asset
    deleteProfilePicture(asset_id) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: `/assets/${asset_id}/profile_img`,
        }).response);
    }
}
//# sourceMappingURL=velavu-api-assets.js.map